import Clipboard from 'clipboard'
import { reportWarn } from './owl'

export function copy(text: string, container?: Element | undefined) {
  return new Promise((resolve, reject) => {
    const fakeElement = document.createElement('button')
    const clipboard = new Clipboard(fakeElement, {
      text: function () {
        return text
      },
      container: typeof container === 'object' ? container : document.body,
    })
    clipboard.on('success', (e) => {
      clipboard.destroy()
      resolve(e)
    })
    clipboard.on('error', (e) => {
      reportWarn({
        name: '复制失败',
        global: true,
      })
      clipboard.destroy()
      reject(e)
    })
    document.body.appendChild(fakeElement)
    fakeElement.click()
    document.body.removeChild(fakeElement)
  })
}
